document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-lcp-product]').forEach((root) => {
    root.querySelectorAll('[data-lcp-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-lcp-media]').forEach((item) => item.classList.remove('is-active'));
        root.querySelector(`[data-lcp-media="${button.dataset.lcpThumb}"]`)?.classList.add('is-active');
      });
    });
  });
  document.querySelectorAll('[data-lcp-submit]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = document.querySelector('.lcp-form');
      if (!form) return;
      const submit = form.querySelector('button[type="submit"]');
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submit || undefined);
      else submit?.click();
    });
  });
});
